import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar, Modal, Table } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { formatDate } from "../../utils/formateDate";
import { useSelector } from "react-redux";

const DownlineDeatils = () => {
  const [selectedMonth, setSelectedMonth] = useState(getLast2Years()?.[0].year);
  const [showSupervisorModal, setShowSupervisorModal] = useState(false);
  const [showLeaderModal, setShowLeaderModal] = useState(false);
  const { t } = useTranslation();
  const [state, setState] = useState([]);
  const data = ApiHook.CallEagleManager(selectedMonth);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const treeListData = ApiHook.CallTreeViewList(selectedUserId);
  const TreeViewList = useSelector((state) => state.tree?.treeViewList);

  const cardStyles = {
  incentiveCard: {
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    padding: '20px',
    margin: '10px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    flex: '1 1 calc(50% - 20px)',
    minWidth: '250px',
    transition: 'transform 0.2s',
    cursor: 'pointer',
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    padding: '20px',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '10px',
    color: '#333',
  },
  cardDescription: {
    fontSize: '14px',
    color: '#666',
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    width: '100%',
  }
};

  // Handle supervisor modal - changed to click instead of hover
  const handleSupervisorClick = (selectedUserId) => {
    setSelectedUser(selectedUserId);
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

  // First, create a helper function to render dots
  const renderDots = (level) => {
    return Array(level)
      .fill("•")
      .map((dot, index) => (
        <span key={`dot-${index}-${level}`} className="dot-symbol">
          {dot}
        </span>
      ));
  };

  const handleToggle = async (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
    setSelectedUserId(id);

    if (!expandedRows[id]) {
      setSelectedUserId(id);
      // Wait for API response before proceeding
      await treeListData.refetch();
    }
  };

  const renderTreeNode = (node, depth = 0) => {
    return (
      <React.Fragment key={`node-${node.id}-${depth}`}>
        <tr>
          <td rowSpan={2}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                paddingLeft: `${depth * 40}px`,
              }}
            >
              {renderDots(node.level)}
              {node.hasChildren && (
                <button
                  className="toggle-button"
                  onClick={() => handleToggle(node.id)}
                >
                  {expandedRows[node.id] ? "−" : "+"}
                </button>
              )}
              <span>{node.fullName || "N/A"}</span>
            </div>
          </td>
          <td rowSpan={2}>
            <div>{node?.tooltipData?.rankDetails?.name || "N/A"}</div>
          </td>
          <td className="data-cell-with-label">
            <span className="data-label">Active KCs</span>
          </td>
          {node.pointsData?.userDataforLastThreeMonths?.map(
            (month, monthIndex) => (
              <td key={monthIndex} className="data-value">
                {month?.activeKC || "0.000"}
              </td>
            )
          )}
          <td>{node.pointsData?.userDataforcurrentYear?.activeKC || "0.00"}</td>
          <td>{node.pointsData?.userDataforLastYear?.activeKC || "0.00"}</td>
          <td rowSpan={2}>
            <button className="view-more-btn" onClick={() => handleSupervisorClick(node.id)}>
              View More
            </button>
          </td>
        </tr>
        <tr className="total-ccs-row">
          <td className="data-cell-with-label">
            <span className="data-label">Total KCs</span>
          </td>
          {node.pointsData?.userDataforLastThreeMonths?.map(
            (month, monthIndex) => (
              <td key={monthIndex} className="data-value">
                {month?.totalKC || "0.000"}
              </td>
            )
          )}
          <td>{node.pointsData?.userDataforcurrentYear?.totalKC || "0.00"}</td>
          <td>{node.pointsData?.userDataforLastYear?.totalKC || "0.00"}</td>
        </tr>

        {/* Recursively render children */}
        {expandedRows[node.id] &&
          node.children?.map((child) => renderTreeNode(child, depth + 1))}
      </React.Fragment>
    );
  };

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">Points History</h6>

            <div className="table-container">
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Level</th>
                    <th></th>
                    {getLast3Months().map((month) => (
                      <th key={month}>{month.value}</th>
                    ))}
                    <th>Current Year</th>
                    <th>Last Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(TreeViewList?.data) &&
                    TreeViewList.data.map((item) => renderTreeNode(item, 0))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showSupervisorModal}
        onHide={closeSupervisorModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Incentives</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <div style={cardStyles.cardContainer}>
       <div style={cardStyles.rowContainer}>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>{t("earned_incentive")}</h3>
          <p style={cardStyles.cardDescription}>
            Description for incentive 1. This includes details about the reward and requirements.
          </p>
          <a href={`incentives/${selectedUser}`}  target="_blank" style={{ textDecoration: 'none', color: '#007bff' }}>
            View Details
          </a>
        </div>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>{t("chairmanBonus")}</h3>
          <p style={cardStyles.cardDescription}>
            Description for incentive 2. This includes details about the reward and requirements.
          </p>
              <a href={`chairman-bonus/${selectedUser}`}  target="_blank" style={{ textDecoration: 'none', color: '#007bff' }}>
            View Details
          </a>
        </div>
      </div>
             <div style={cardStyles.rowContainer}>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>Global Rally</h3>
          <p style={cardStyles.cardDescription}>
            Description for incentive 1. This includes details about the reward and requirements.
          </p>
               <a href={`global-rally/${selectedUser}`} target="_blank" style={{ textDecoration: 'none', color: '#007bff' }}>
            View Details
          </a>
        </div>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>Eagle Manager</h3>
          <p style={cardStyles.cardDescription}>
            Description for incentive 2. This includes details about the reward and requirements.
          </p>
               <a href={`eagle-manager/${selectedUser}`} target="_blank" style={{ textDecoration: 'none', color: '#007bff' }}>
            View Details
          </a>
        </div>
      </div>
             {/* <div style={cardStyles.rowContainer}>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>Leadership Bonus</h3>
     
        </div>
        <div style={cardStyles.incentiveCard}>
          <h3 style={cardStyles.cardTitle}>Recent Orders</h3>

        </div>
      </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
      
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DownlineDeatils;
